module.exports = __webpack_public_path__ + "static/media/chevron-down.65a20b06.svg";